// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyToolsScreen_wrapper__4nX5P","title":"EmptyToolsScreen_title__cbOUA","text":"EmptyToolsScreen_text__ucj7M"};